import React from "react";
import "./Basket_crane_rental.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";
import { Helmet } from "react-helmet";

export default function Basket_crane_rental() {

  const seo = {
    title:
      "השכרת מנוף סל | מנוף סל לעבודות בגובה | ש.מ הובלות ומנופים",
    description:
      "השכרת מנוף סל לעבודות בגובה עבור קבלנים, חברות, עסקים, אנשי מקצוע ולקוחות פרטיים. שירותי מנוף סל לתחזוקה, התקנות, גיזום עצים, שילוט, תאורה ועבודות בגובה, בהתאם לתנאי השטח.",
    url:
      "https://smtovala.co.il/Basket_crane_rental",
    image:
      "https://smtovala.co.il/images/6.png"
  };

  return (
    <div className="Crane_work_nationwide-page">

      {/* =====================================================
          SEO
      ===================================================== */}

      <Helmet>

        <title>{seo.title}</title>

        <meta
          name="description"
          content={seo.description}
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />

        <link
          rel="canonical"
          href={seo.url}
        />

        {/* Open Graph */}

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:title"
          content={seo.title}
        />

        <meta
          property="og:description"
          content={seo.description}
        />

        <meta
          property="og:url"
          content={seo.url}
        />

        <meta
          property="og:image"
          content={seo.image}
        />

        <meta
          property="og:site_name"
          content="ש.מ הובלות ומנופים"
        />

        <meta
          property="og:locale"
          content="he_IL"
        />

        {/* Twitter */}

        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content={seo.title}
        />

        <meta
          name="twitter:description"
          content={seo.description}
        />

        <meta
          name="twitter:image"
          content={seo.image}
        />

      </Helmet>


      {/* =====================================================
          HERO - כותרת עליונה
      ===================================================== */}
   <div className="Basket_crane_rental-page">


      <div className="Basket_crane_rental-hero">

        <div className="Basket_crane_rental-overlay">

          <h1>השכרת מנוף סל</h1>

        </div>

      </div>

      </div>

      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">


          {/* =====================================================
              VIDEO - ראשון
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              השכרת מנוף סל
            </div>



          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">

            השכרת מנוף סל מאפשרת לבצע מגוון רחב של עבודות בגובה,
            כאשר נדרשת גישה נוחה ומדויקת לאזור העבודה. ש.מ הובלות
            ומנופים מספקת שירותי מנוף סל לקבלנים, חברות, עסקים,
            אנשי מקצוע ולקוחות פרטיים, תוך התאמת אופן העבודה לגובה,
            לסוג המשימה ולתנאים הקיימים בשטח.

          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">

              <img
                src="/images/6.png"
                alt="השכרת מנוף סל"
              />

            </div>

            <div className="text-box">

              <p>
                מנוף סל מתאים לעבודות שבהן יש צורך להעלות אנשי מקצוע
                לגובה ולבצע את המשימה מתוך סל עבודה. לפני תחילת
                העבודה יש לבחון את גובה העבודה, מיקום המבנה או
                האובייקט, אפשרויות הגישה והמקום שבו ניתן להציב
                את המשאית.
              </p>

              <p>
                ש.מ הובלות ומנופים מעניקה פתרונות לעבודות בגובה
                באמצעות מנוף סל, בין היתר עבור תחזוקה, התקנות,
                גיזום עצים, שילוט, תאורה, ניקוי מבנים ועבודות
                מקצועיות נוספות בהתאם לצורך ולתנאי השטח.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            השכרת מנוף סל – התאמת הפתרון לעבודה
          </h2>

          <div className="bottom-text">

            <p>
              לפני שמזמינים מנוף סל חשוב להגדיר את מטרת העבודה
              ולבדוק מהו הגובה שאליו נדרשת גישה. בנוסף, יש להביא
              בחשבון את מיקום המשימה, המרחק מהמשאית ואת השטח
              שבו המנוף אמור לעבוד.
            </p>

            <p>
              תכנון מוקדם של העבודה מאפשר לבחור את דרך הביצוע
              המתאימה יותר ולצמצם הפתעות במהלך ההגעה לאתר.
              לכן חשוב למסור מראש פרטים על סוג העבודה, הגובה
              הנדרש והמיקום שבו היא מתבצעת.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              מנוף סל לעבודות בגובה
            </h2>

            <p>
              מנוף סל נועד לאפשר גישה של עובדים ואנשי מקצוע
              לאזורים גבוהים, כאשר העבודה מהקרקע אינה מספקת
              את הגישה הנדרשת. השימוש במנוף יכול להתאים למבנים,
              מתקנים, עצים, שלטים ונקודות עבודה שונות.
            </p>

            <p>
              ניתן להיעזר במנוף סל עבור עבודות תחזוקה, התקנות,
              תיקונים, עבודות חשמל, התקנת תאורה, שילוט, ניקוי
              ועבודות נוספות בגובה, בהתאם לאופי הפרויקט.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              השכרת מנוף סל לאתרי בנייה, מפעלים ועסקים
            </h2>

            <p>
              באתרי בנייה ובמתחמים עסקיים ותעשייתיים מתבצעות
              עבודות רבות בגובה, החל מהתקנת מערכות וציוד ועד
              תחזוקת מבנים ותשתיות. מנוף סל יכול לספק גישה
              לאזורים שבהם נדרשת עבודה מעל פני הקרקע.
            </p>

            <p>
              ש.מ הובלות ומנופים מספקת שירותי מנוף סל לאתרי
              בנייה, מפעלים, עסקים, מחסנים, מבנים מסחריים
              ולקוחות פרטיים. העבודה מתוכננת בהתאם למיקום,
              לגובה ולסוג המשימה.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              מנוף סל לגיזום עצים ועבודות גינון
            </h2>

            <p>
              כאשר מדובר בעצים גבוהים, עבודות גיזום ותחזוקה
              עשויות לדרוש גישה אל הענפים והחלקים העליונים של
              העץ. מנוף סל מאפשר להגיע לאזור העבודה מגובה
              בהתאם לתנאי השטח ולאפשרויות ההצבה במקום.
            </p>

            <p>
              לפני ביצוע העבודה יש לבדוק את מיקום העץ, את
              המרחק מהכביש או מהחניה, את אפשרות הצבת המשאית
              ואת הגובה שאליו נדרשת גישה. נתונים אלה מסייעים
              בתכנון נכון של העבודה.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              מנוף סל להתקנות, תחזוקה ושירות בגובה
            </h2>

            <p>
              מנוף סל יכול להתאים לעבודות התקנה ותחזוקה רבות,
              כגון התקנת שלטים, גופי תאורה, מצלמות, מערכות
              שונות, עבודות ניקוי, תיקונים ותחזוקה של מבנים
              ומתקנים.
            </p>

            <p>
              בהתאם לאופי המשימה ניתן לתכנן את מיקום המשאית
              ואת טווח העבודה כך שאנשי המקצוע יוכלו להגיע
              לאזור הנדרש ולבצע את העבודה בצורה מסודרת.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור שירות מקצועי להשכרת מנוף סל?
            </h2>

            <p>
              עבודות בגובה מחייבות התייחסות למספר גורמים,
              בהם גובה העבודה, תנאי הקרקע, אפשרויות הגישה,
              מיקום המשאית וסביבת העבודה. בדיקה מוקדמת של
              התנאים יכולה לסייע בתכנון נכון של המשימה.
            </p>

            <p>
              ש.מ הובלות ומנופים מתאימה את שירות מנוף הסל
              לצורכי העבודה ולתנאי המקום. בעת תכנון העבודה
              נלקחים בחשבון סוג המשימה, הגובה הנדרש, נקודת
              ההצבה והגישה לאזור העבודה.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              ש.מ הובלות ומנופים – השכרת מנוף סל ברחבי הארץ
            </h2>

            <p>
              ש.מ הובלות ומנופים מספקת שירותי השכרת מנוף סל
              לעבודות בגובה עבור קבלנים, חברות, עסקים, אנשי
              מקצוע ולקוחות פרטיים. השירות מתאים למגוון
              משימות ומותאם ככל שניתן לתנאים הקיימים באתר.
            </p>

            <p>
              מחפשים מנוף סל לעבודה בגובה? צרו קשר עם
              ש.מ הובלות ומנופים ומסרו לנו את מיקום העבודה,
              הגובה הנדרש וסוג המשימה. נבחן את פרטי העבודה
              ונכוון אתכם לפתרון המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Renting_a_basket_crane_for_lifting_a_person"
              className="link-right"
            >
              השכרת מנוף סל להרמת אדם
            </Link>

            <Link
              to="/Crane_Rental1"
              className="link-left"
            >
              השכרת מנוף זרוע
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}
